export { default } from "./PageViewTrigger";
